import React from 'react';
import { ContainerProps } from '../../types';

export const Container: React.FC<ContainerProps> = ({ children, className = '' }) => (
  <div className={`container ${className}`}>
    {children}
  </div>
);

export default Container;